export enum SMapWhen {
  ALWAYS = 'ALWAYS',
  CONDITION = 'CONDITION',
  EXCLUDE_CONDITION = 'EXCLUDE_CONDITION',
}

export enum SMapStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum SMapConditionLogic {
  AND = 'AND',
  OR = 'OR',
}

export enum SMapFieldFormat {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  FORMULA = 'FORMULA',
  DATE_RANGE = 'DATE_RANGE',
}

export enum SMapFormulaType {
  MULTIPLICATION = 'MULTIPLICATION',
  DIVISION = 'DIVISION',
}

export enum SMapFieldAction {
  OVERWRITE_ALWAYS = 'OVERWRITE_ALWAYS',
  OVERWRITE_IF_EMPTY = 'OVERWRITE_IF_EMPTY',
  CLEAR_FIELD = 'CLEAR_FIELD',
  PASSTHROUGH_VALUE = 'PASSTHROUGH_VALUE',
  DO_NOTHING = 'DO_NOTHING',
}

export enum SMapMatch {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  STARTS_WITH = 'STARTS_WITH',
  NOT_STARTS_WITH = 'NOT_STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  NOT_ENDS_WITH = 'NOT_ENDS_WITH',
  EXISTS = 'EXISTS',
  NOT_EXISTS = 'NOT_EXISTS',
  ONE_OF = 'ONE_OF',
  NOT_ONE_OF = 'NOT_ONE_OF',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  REGEX = 'REGEX',
  CONFLICTS = 'CONFLICTS',
  NOT_CONFLICTS = 'NOT_CONFLICTS',
}

export enum ImportProcessingType {
  SPECIAL_MAP = 'Special Map',
  SPECIAL_DATA_RULE = 'Special Data Rule',
}
